import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Convinience from "./convinience/Convinience";
import Qucik_Rides from "./qucik_rides/Qucik_Rides";
import What_Makes_Us_Special from "./what_makes_us_special/What_Makes_Us_Special";
import Made_For_Your_Everyday_Moves from "./made_for_your_everyday_moves/Made_For_Your_Everyday_Moves";
import Why_Choose_Us from "./why_choose_us/Why_Choose_Us";
import Swiper_image from "./swiper_image/Swiper_image";
import How_We_Work from "./how_we_work/How_We_Work";
import Stop_Waiting from "./stop_waiting/Stop_Waiting";
import { useEffect } from "react";
import { AppSetup } from "../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";

function Home() {
  const dispatch = useDispatch();

  const appsetups = useSelector((state) => state.common.all_appsetup);

  useEffect(() => {
    dispatch(AppSetup());
  }, [dispatch]);

  return (
    <>
      <Banner appsetups={appsetups} />
      <Convinience />
      <Why_Choose_Us />
      <What_Makes_Us_Special />
      <Qucik_Rides />
      <Made_For_Your_Everyday_Moves />
      <Swiper_image />
      <How_We_Work />
      <Stop_Waiting />
    </>
  );
}

export default Home;
